import { Text } from '@yes.technology/react-toolkit'
import { Optional, Record, String, Unknown } from 'runtypes'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'

export type TextExpressionContainerProps = {
  props: {
    des: string
    styleMap?: StyleMap
    variant?: React.ComponentProps<typeof Text>['variant']
  }
}

export const TextExpressionContainerTypeGuard = Record({
  des: String,
  styleMap: Optional(Unknown),
  variant: Optional(String)
})
